<template>
  <div class="register" :class="{'show_long':isCheck,'success_long':is_success}">
    <div class="pc_reg" @scroll.stop>
      <div class="reg_title">
        <p>用户注册</p>
        <span @click="closeReg()"></span>
      </div>
      <div class="reg_info">
        <div class="box_one" v-if="!is_success">
          <!-- <div class="reg_menu">
            <span v-for="(menu,index) in menus" :key="index" @click="showReg(index)" :class="{'choose_menu':chooseIndex === index}">{{menu}}</span>
          </div> -->
          <div class="user_info">
            <div class="pass_register">
              <div class='set_box' :class="{'recover':acc_tip}" v-if="chooseIndex === 0">
                <input type='text' placeholder='用户名' @blur="judgeInfo(0)" :class="'log-input' + (account==''?' log-input-empty':'')" name='account' v-model='account'>
                <i v-if="acc_tip"></i>
                <div class="tip" v-if="acc_tip">请用6-20位数字、字母命名</div>
                <div class="tip" v-if="had_acc_reg === 1">该账号已被注册，请重新命名</div>
              </div>
              <div class="bind_phone" v-if="chooseIndex === 1">
                <div class='set_box' :class="{'recover':phone_tip}">
                  <input type='text' placeholder='手机号码' @blur="judgeInfo(7)" :class="'log-input' + (account==''?' log-input-empty':'')"  v-model='phone'>
                  <i v-if="phone_tip"></i>
                  <div class="tip" v-if="phone_tip">请输入正确的手机号</div>
                  <div class="tip" v-if="had_phone_reg === 1">该账号已被注册，请重新命名</div>
                </div>
                <div class="code_box set_box">
                  <div style="margin-bottom: 0">
                    <input type='text' placeholder='短信验证码' @blur="judgeInfo(8)" class="code" v-model='ver_code'>
                    <i style="right: 133px" v-if="code_tip"></i>
                  </div>
                  <span class="get_code" v-if='getting === false' @click="getVerCode()">获取验证码</span>
                  <span class="get_code" v-if='getting'>{{ get_time }}s</span>
                  <div class="tip" v-if="code_tip">请输入正确的验证码</div>
                </div>
              </div>
              <div class='set_box' :class="{'recover':pwd_tip}">
                <input type='password' placeholder='密码' @blur="judgeInfo(1)" :class="'log-input' + (password==''?' log-input-empty':'')" v-model='password'>
                <i v-if="pwd_tip"></i>
                <div class="tip" v-if="pwd_tip">请用6-20位数字、字母设置密码</div>
              </div>
              <div class='set_box' :class="{'recover':confirm_tip !== false}">
                <input type='password' placeholder='确认密码' @blur="judgeInfo(2)" :class="'log-input' + (confirm_pwd==''?' log-input-empty':'')" v-model='confirm_pwd'>
                <i v-if="confirm_tip"></i>
                <div class="tip" v-if="confirm_tip">{{confirm_tip}}</div>
              </div>
              <div class="set_box" style="min-height: auto">
                <div style="margin-bottom: 0">
                  <!-- <input class="check" type="checkbox" ref="binding" @click="showDq()"> -->
                  <span>绑定《我在大清当皇帝》游戏账号</span>
                </div>
                <p v-if="isCheck">《我在大清当皇帝》账号需要填写正确实名信息才可绑定，绑定成功后可用已注册的俱乐部账号进行登录</p>
              </div>
              <div class="dq_account" v-if="isCheck">
                <div class='set_box'>
                  <input type='text' placeholder='请输入游戏账号' @blur="judgeInfo(9)" :class="'log-input' + (dq_account==''?' log-input-empty':'')" v-model='dq_account'>
                  <i v-if="had_dq_account"></i>
                  <div v-if="had_dq_account" class="tip">请输入游戏账号</div>
                </div>
                <div class='set_box'>
                  <input type='password' placeholder='请输入密码' @blur="judgeInfo(3)" :class="'log-input' + (dq_password==''?' log-input-empty':'')" v-model='dq_password'>
                   <i v-if="had_dq_reg"></i>
                  <div v-if="had_dq_reg" class="tip">{{had_dq_reg}}</div>
                </div>
                <div class="set_box">
                  <select v-model="dq_app">
                    <option v-for="(data,index) in appBox" :key="index" :value="data.value">{{data.label}}</option>
                  </select>
                  <i class="drop_down"></i>
                </div>
              </div>
              <div class='set_box' :class="{'recover':name_tip}">
                <input type='text' placeholder='真实姓名' @blur="judgeInfo(5)" :class="'log-input' + (user_name==''?' log-input-empty':'')" v-model='user_name'>
                <i v-if="name_tip"></i>
                <div class="tip" v-if="name_tip">请填写正确的格式</div>
              </div>
              <div class='set_box' :class="{'recover':identity_tip}">
                <input type='text' placeholder='身份证号码' @blur="judgeInfo(6)" :class="'log-input' + (user_identity==''?' log-input-empty':'')" v-model='user_identity'>
                <i v-if="identity_tip"></i>
                <div class="tip" v-if="identity_tip">身份证号输入不正确</div>
                <div class="tip" v-if="had_identity_reg === 1||had_identity_reg === 2">该身份证号不符合/未实名认证</div>
              </div>
              <div class='agree'>
                <input class="input_check" type="checkbox"  v-model="is_agree">
                <label class="agreement">阅读并同意<router-link to="/protocol" target="_blank">九龙阁会员俱乐部注册协议</router-link></label>
              </div>
              <div class="agree">
                <div class="tip" v-if="agree">请阅读并同意九龙阁会员协议</div>
              </div>
              <div class='set_box' style="min-height: 25px" v-if="tipInfo !==''">
                <div class="tip">{{tipInfo}}，请重新输入！</div>
                <!--<div class="tip">信息填写错误，请重新输入！</div>-->
              </div>
              <span class="reg_btn" @click="sendRegInfo()">快速注册</span>
              <p class="login">已有账号， 请<span @click="toLogin()">登录</span></p>
            </div>
            <div class="phone_register"></div>
          </div>
        </div>
        <div class="box_two" v-if="is_success">
          <img src="../../../static/img/forget_pwd/success_icon.png">
          <p>恭喜，注册成功</p>
        </div>
      </div>
    </div>
    <Loading v-if='loading'></Loading>
  </div>
</template>

<script>
import md5 from 'js-md5'
import Loading from './loading'
export default {
  data () {
    return {
      menus: ['通行证注册', '手机号注册'],
      // appBox: [{
      //   name: 'Android',
      //   id: 1004
      // }, {
      //   name: 'IOS',
      //   id: 1003
      // }],
      appBox: null,
      chooseIndex: 1,
      isCheck: true,
      account: '',
      password: '',
      confirm_pwd: '',
      dq_account: '',
      dq_password: '',
      dq_guid: '',
      is_bind: 1,
      dq_app: 1004,
      user_name: '',
      user_identity: '',
      ver_code: '',
      phone: '',
      register_type: '',
      agree: false,
      is_agree: false,
      getting: false,
      get_time: 60,
      acc_tip: false,
      pwd_tip: false,
      confirm_tip: false,
      dq_acc_tip: false,
      dq_pwd_tip: false,
      name_tip: false,
      identity_tip: false,
      phone_tip: false,
      code_tip: false,
      had_acc_reg: '',
      had_phone_reg: '',
      had_dq_reg: false,
      had_dq_account: '',
      had_identity_reg: '',
      tipInfo: '',
      loading: false,
      is_success: false,
      is_next: false,
      formData: {}
    }
  },
  components: {
    Loading
  },
  methods: {
    // 返回登录页
    comeBack () {
      this.$store.dispatch('change_login_show', true)
      this.$store.dispatch('change_reg_show', false)
    },
    // showReg (index) {
    //   this.chooseIndex = index
    //   this.initData()
    // },
    setPhone () {
      this.chooseIndex = 1
    },
    nextFun () {
      this.judgeInfo(1)
      this.judgeInfo(7)
      this.judgeInfo(8)
      if (!this.phone_tip && !this.pwd_tip && !this.code_tip) {
        this.is_next = true
      }
    },
    // 原先写死的安卓、ios，现在动态获取
    getGamePhoneType () {
      this.axios.get('/api/interface/app_info?game_id=102').then(res => {
        if (res.data.state === 0) {
          this.appBox = res.data.data
        }
      })
    },
    // 是否绑定大清账号
    // showDq () {
    //   this.isCheck = document.body.clientWidth < 767 ? this.$refs.phone_binding.checked : this.$refs.binding.checked
    //   if (this.isCheck === true && this.appBox === null) {
    //     this.getGamePhoneType()
    //   }
    //   // this.isCheck = this.$refs.binding.checked
    //   this.is_bind = this.isCheck ? 1 : 0
    // },
    // 关闭弹窗
    closeReg () {
      this.$store.dispatch('change_login_show', false)
      this.$store.dispatch('change_reg_show', false)
      // 数据清空
      this.initData()
      this.chooseIndex = 1
      // window.location.reload()
    },
    initData () {
      // this.$refs.binding.checked = false
      // this.$refs.phone_binding.checked = false
      this.isCheck = true
      this.agree = false
      this.is_agree = false
      this.getting = false
      this.acc_tip = false
      this.pwd_tip = false
      this.confirm_tip = false
      this.dq_acc_tip = false
      this.dq_pwd_tip = false
      this.name_tip = false
      this.identity_tip = false
      this.phone_tip = false
      this.code_tip = false
      this.is_success = false
      this.tipInfo = ''
      this.account = ''
      this.password = ''
      this.confirm_pwd = ''
      this.dq_account = ''
      this.dq_password = ''
      this.is_bind = 1
      this.dq_app = 1004
      this.user_name = ''
      this.user_identity = ''
      this.ver_code = ''
      this.phone = ''
      this.register_type = ''
      this.had_dq_reg = false
      this.had_dq_account = ''
      this.had_acc_reg = ''
      this.had_phone_reg = ''
      this.had_identity_reg = ''
    },
    toLogin () {
      this.$store.dispatch('change_login_show', true)
      this.$store.dispatch('change_reg_show', false)
      this.initData()
    },
    // 以下为注册输入框填写判断
    judgeInfo (index) {
      var accPattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
      var uPattern = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/
      var namePattern = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}|[a-zA-Z]{2,20}$/
      var verPattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      var phPattern = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/

      this.tipInfo = ''

      // 验证账号
      if (index === 0) {
        this.acc_tip = !accPattern.test(this.account)
        if (this.acc_tip) {
          this.had_acc_reg = ''
        }
        if (this.account !== '' && !this.acc_tip) {
          this.getAccData()
        }
        // 验证密码
      } else if (index === 1) {
        this.pwd_tip = !uPattern.test(this.password)
        // 验证确认密码和密码一致性
      } else if (index === 2) {
        if (this.confirm_pwd === '' || this.confirm_tip === undefined) {
          this.confirm_tip = '确认密码不能为空'
        } else if (this.password !== '') {
          this.confirm_tip = this.confirm_pwd !== this.password ? '两次密码输入不一致' : false
        } else {
          this.confirm_tip = false
        }
        // 验证是否绑定大清账号
      } else if (index === 3) {
        if (this.dq_password === '') {
          this.had_dq_reg = '大清密码不能为空'
        } else if (this.dq_password !== '' && this.dq_account !== '') {
          this.getDqData()
        } else {
          this.had_dq_reg = false
        }
      } else if (index === 4) {
        // 验证姓名
      } else if (index === 5) {
        this.name_tip = !namePattern.test(this.user_name)
        // 验证身份证
      } else if (index === 6) {
        this.identity_tip = !verPattern.test(this.user_identity)
        if (this.identity_tip) {
          this.had_identity_reg = ''
        }
        if (this.user_identity !== '' && !this.identity_tip && this.is_bind === 1) {
          this.getIdentityData()
        }
        // 验证手机
      } else if (index === 7) {
        this.phone_tip = !phPattern.test(this.phone)
        if (this.phone_tip) {
          this.had_phone_reg = ''
        }
        if (this.phone !== '' && !this.phone_tip) {
          this.getPhoneData()
        }
        // 验证验证码
      } else if (index === 8) {
        this.code_tip = this.ver_code === ''
      } else if (index === 9) {
        if (this.dq_account === '') {
          this.had_dq_account = '请输入大清游戏账号'
        } else {
          this.had_dq_account = ''
        }
      }
    },
    // 获取验证码
    getVerCode () {
      if (this.had_phone_reg !== 1) {
        this.get_time = 60
        if (this.phone !== '') {
          this.getting = true
          var authTimetimer = setInterval(() => {
            this.get_time--
            if (this.get_time <= 0) {
              this.getting = false
              clearInterval(authTimetimer)
            }
          }, 1000)
          var formData = {
            account: this.phone,
            type: 'phone',
            use: 1
          }
          this.axios.post('/api/interface/account/send_verification_code', formData).then(res => {
            if (res.data.state === 0) {
            } else {
            }
          })
        } else {
          this.judgeInfo(7)
        }
      }
    },
    // 判断用户名是否已被注册
    getAccData () {
      this.had_acc_reg = ''
      // var accData = {
      //   account: this.account
      // }
      // this.axios.post('/api/interface/account/check_account', accData).then(res => {
      //   if (res.data.state === 0) {
      //     this.had_acc_reg = res.data.result
      //   }
      // })
    },
    // 判断手机号是否已被注册
    getPhoneData () {
      this.had_acc_reg = ''
      // var phoneData = {
      //   field: this.phone,
      //   type: 'phone'
      // }
      // this.axios.post('/api/interface/account/check_account_bound', phoneData).then(res => {
      //   if (res.data.state === 0) {
      //     this.had_phone_reg = res.data.result
      //   }
      // })
    },
    // 判断大清账号的正确性
    getDqData () {
      var infoData = {
        account: this.dq_account,
        psw: this.dq_password,
        app_id: this.dq_app
      }
      this.axios.post('/api/interface/account/check_dq_account', infoData).then(res => {
        if (res.data.state === 0) {
          this.guid = res.data.guid
          this.had_dq_reg = res.data.result === 0 ? false : '账号或密码错误'
        }
      })
    },
    // 判断用户身份证是否存在
    getIdentityData () {
      var identityData = {
        app_id: this.dq_app,
        guid: this.guid,
        identity_number: this.user_identity
      }
      this.axios.post('/api/interface/account/check_identity', identityData).then(res => {
        if (res.data.state === 0) {
          this.had_identity_reg = res.data.result
        }
      })
    },
    check () {
      this.judgeInfo(7)
      this.judgeInfo(8)
      this.judgeInfo(1)
      this.judgeInfo(2)
      this.judgeInfo(9)
      this.judgeInfo(3)
      this.judgeInfo(5)
      this.judgeInfo(6)

      return !this.phone_tip &&
        !this.code_tip &&
        !this.pwd_tip &&
        !this.confirm_tip &&
        !this.had_dq_account &&
        !this.had_dq_reg &&
        !this.name_tip &&
        !this.identity_tip &&
        this.had_identity_reg !== 1 &&
        this.had_identity_reg !== 2
    },
    // 发送注册信息
    sendRegInfo () {
      this.tipInfo = ''
      if (!this.check()) return

      var that = this
      this.loading = true
      this.agree = !this.is_agree
      this.register_type = this.chooseIndex === 0 ? 'normal' : 'phone'
      this.account = this.register_type === 'phone' ? this.phone : this.account
      let passwordMd5 = md5(this.password)
      var infoData = {
        account: this.account,
        password: passwordMd5,
        binding_dq: this.is_bind,
        name: this.user_name,
        identify_number: this.user_identity,
        register_type: this.register_type
      }
      if (this.is_bind === 1) {
        infoData['dq_account'] = this.dq_account
        infoData['dq_password'] = this.dq_password
        infoData['dq_app_id'] = this.dq_app
      }
      if (this.register_type === 'phone') {
        infoData['verification_code'] = this.ver_code
      }
      if (that.is_agree) {
        this.axios.post('/api/interface/account/register', infoData).then(res => {
          that.loading = false
          if (res.data.state === 0) {
            this.is_success = true
            setTimeout(function () {
              that.login()
            }, 0)
          } else {
            // 注册失败，显示错误信息
            this.tipInfo = res.data.msg
          }
        })
        // this.loading = false
        // this.is_success = true
      } else {
        that.loading = false
      }
    },
    login () {
      let passwordMd5 = md5(this.password)
      this.account = this.register_type === 'phone' ? this.phone : this.account
      this.formData['account'] = this.account
      this.formData['pwd'] = passwordMd5
      this.formData['login_type'] = 'pc'
      this.formData['type'] = 'pc'
      this.axios.post('/api/interface/login', this.formData).then(res => {
        if (res.data.state === 0) {
          this.$store.commit('SET_BASEINFO', {account: this.account, password: passwordMd5, token: res.data.token, id: res.data.uid, is_first: res.data.is_first, is_bind: res.data.is_bind})
          this.setCookie(res.data.token, 30)
          window.location.reload()
        } else {
          this.password = ''
        }
      })
    },
    // 设置cookie
    setCookie (token, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'Access-Token' + '=' + token + ';path=/;expires=' + exdate.toGMTString()
    }
  },
  mounted () {
    this.getGamePhoneType()
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.show_long{
  top:5%!important;
}
.success_long{
  top:32%!important;
}
.register{
  width: 439px;
  background-color: #fff;
  border-radius: 5px;
  position: fixed;
  top:15%;
  left: 50%;
  margin-left: -220px;
  z-index: 15;
  .pc_reg{
    max-height: 90vh;
    overflow: auto;
    .reg_title{
      height: 86px;
      width: 100%;
      position: relative;
      p{
        width: 100%;
        line-height: 86px;
        letter-spacing: 3px;
        font-size: 28px;
        color: #fff;
        background:url("../../../static/img/common/login_header.png")no-repeat;
      }
      span{
        position: absolute;
        right: 5px;
        top:10px;
        display: block;
        width: 41px;
        height: 40px;
        cursor: pointer;
        &:hover:before {
          -webkit-transform: rotate(-135deg);
          -ms-transform: rotate(-135deg);
          transform: rotate(-135deg);
        }
        &:hover:after {
          -webkit-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          transform: rotate(-45deg);
        }

        &:hover:before, &:hover:after {
          -webkit-transition: -webkit-transform .3s ease-out;
          transition: -webkit-transform .3s ease-out;
          transition: transform .3s ease-out;
          transition: transform .3s ease-out, -webkit-transform .3s ease-out;
        }
        &:before {
          -webkit-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          transform: rotate(-45deg);
        }
        &:after {
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }
        &:before, &:after {
          position: absolute;
          top: 28px;
          right: 12px;
          content: "";
          width: 27px;
          height: 2px;
          background: #fff;
          -webkit-transition: -webkit-transform 0.5s ease-out;
          transition: -webkit-transform 0.5s ease-out;
          transition: transform 0.5s ease-out;
          transition: transform 0.5s ease-out, -webkit-transform 0.5s ease-out;
        }
      }
    }
    .reg_info{
      width: 354px;
      margin: 0 auto;
      .reg_menu{
        width: 100%;
        display: table;
        span{
          width: 50%;
          float: left;
          line-height: 38px;
          margin: 10px 0 15px 0;
          font-size: 18px;
          color: #4f4f4f;
          border-bottom:2px solid #4f4f4f ;
          letter-spacing: 1px;
          cursor: pointer;
        }
        .choose_menu{
          color: #b60105;
          border-bottom:2px solid #b60105;
        }
      }
      .user_info{
        width: 100%;
        margin-top: 55px;
        .code_box{
          height: 100%;
          div{
            width: 228px!important;
            float: left;
            .code{
              width: 100%;
            }
          }
          .get_code{
            cursor: pointer;
            display: block;
            width: 116px;
            line-height: 43px;
            float: left;
            margin-left: 10px;
            font-size: 14px;
            color: #fff;
            letter-spacing: 1px;
            background: url("../../../static/img/common/code_btn.png")no-repeat;
          }
        }
        .recover{
          margin-bottom: 5px!important;
        }
        .set_box{
          display: table;
          width: 100%;
          min-height: 43px;
          margin-bottom: 12px;
          position: relative;
          input{
            background-color: #fff;
            border: 1px solid #c5c5c5;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #1f2d3d;
            height: 43px;
            padding: 3px 30px 3px 10px;
            -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            float: left;
            width: 100%;
            font-size: 14px;
            &:focus {
              border-color: #d1434a;
            }
          }
          div{
            width: 100%;
            margin-bottom: 10px;
            display: table;
            .check{
              width: 14px;
              height: 14px;
              border: 1px solid #424242;
              border-radius: 100%;
              vertical-align: middle;
              margin-right:10px;
              padding: 0;
              float: left;
              -webkit-appearance: none;
              &:checked {
                border-radius:0;
                border: none !important;
                background: url("../../../static/img/user_center/choose.png")no-repeat;
              }
            }
            span{
              font-size: 14px;
              float: left;
            }
          }
          p{
            font-size: 12px;
            text-align: left;
            color: #b50105;
            line-height: 15px;
            margin-top: 5px;
          }
          select{
            float: left;
            width: 100%;
            height: 43px;
            padding: 0 30px 0 10px;
            border: 1px solid #c5c5c5;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            overflow: hidden;
          }
          .drop_down{
            position: absolute;
            width: 0;
            height: 0;
            top: 17px;
            right: 11px;
            border:8px solid #b3b3b3;
            border-width: 8px 8px 8px;
            border-color: #5a5a5a transparent transparent transparent;
            z-index: 2;
            pointer-events:none;
            background: none;
          }
          i{
            position: absolute;
            top: 14px;
            right: 8px;
            display: inline-block;
            width: 14px;
            height: 14px;
            background:url("../../../static/img/user_center/default_icon.png")no-repeat;
          }
        }
        .tip{
          width: 100%;
          padding-top: 5px;
          font-size: 12px;
          color: #b50105;
          text-align: left;
          margin-bottom: 0;
        }
        .agree{
          position: relative;
          font-size: 14px;
          margin-bottom: 15px;
          text-align: left;
          input[type="checkbox"] + label::before {
            content: "\a0";
            display: inline-block;
            vertical-align: 1px;
            width: 10px;
            height: 12px;
            margin-right: 5px;
            padding-left: 1px;
            border: 1px solid #999;
            line-height: 0.75;
            border-radius: 3px;
          }
          input[type="checkbox"]:checked + label::before {
            content: "\2713";
            background-color: #fff;
            border: 1px solid #999;
            color: #111;
          }
          input {
            position: absolute;
            top: 50%;
            left: 0;
            cursor: pointer;
            -webkit-transform: translate(0, -50%);
            -ms-transform: translate(0, -50%);
            transform: translate(0, -50%);
            opacity: 0;
            &.clicked_ok + label::before {
              border: 1px solid #f00;
            }
          }
          .agreement{
            a{
              color: #b50105;
              cursor: pointer;
            }
          }
        }
        .reg_btn{
          display: block;
          width: 100%;
          height: 77px;
          background: url("../../../static/img/common/login_btn.png")no-repeat;
          background-position: -40px 0;
          line-height: 60px;
          color: #fff;
          font-size: 26px;
          letter-spacing: 2px;
          cursor: pointer;
        }
        .login{
          font-size: 14px;
          margin: 5px 0 40px 0;
          span{
            color: #B50105;
            cursor: pointer;
          }
        }
      }
      .box_two{
        padding: 45px 0;
        img{
          width: 62px;
          height: 61px;
          margin: 0 auto;
        }
        p{
          font-size: 26px;
        }
        span{
          display: block;
          margin-top: 20px;
          width: 100%;
          font-size: 16px;
          color: #b20005;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Register.vue